import React from 'react';
import { Route as BaseRoute, RouteProps } from 'react-router-dom';
import { EContext } from './EContext';
import NotFound from '../../pages/errors/NotFound/NotFound';
import LegacyFrameNavigator from '../../../legacy/FrameNavigator';
import removeQueryString from '../../../utilities/removeQueryString';
import trace from '../../../utilities/trace';

interface Props extends RouteProps {
    component?: any;
    path: string;

    /**
     * Called after legacy route is done navigating.
     *
     * @memberof Props
     */
    onNavigated?: (frame: string) => void;
}

const temporaryWhitelist = ['/inbox/documents/:id/viewer'];

export default function Route({ path, onNavigated, ...props }: Props) {
    const { routes } = React.useContext(EContext);
    const sanitizedPath = removeQueryString(path);
    const isAuthorized = routes.hasOwnProperty(sanitizedPath);

    if (!isAuthorized && !temporaryWhitelist.includes(sanitizedPath)) {
        trace.info('Not authorized for ' + sanitizedPath);
        return <BaseRoute component={NotFound} />;
    }

    const route = routes[sanitizedPath];

    // legacy (firebird) route's don't have components
    if (!props.component && !props.render) {
        if (route && route.length) {
            return (
                <BaseRoute
                    {...props}
                    path={sanitizedPath}
                    render={props => <LegacyFrameNavigator {...props} onNavigated={onNavigated} legacyUrl={route} />}
                />
            );
        } else {
            // log something somewhere, we have a "legacy" route with no actual url
        }
    }

    return <BaseRoute {...props} path={sanitizedPath} />;
}
